import { CardVariations } from "@particles/card/utils/types";

export const CARD_BASE_VARIANT: CardVariations = {
  image: { position: "", width: "w-full" },
  content: {
    extraClass: "pt-2",
    width: "w-full",
    updatedTimeColor: "text-red mt-1",
  },
  title: {
    color: "text-gray-850",
    size: "text-base",
    extraClass: "font-lct my-1",
  },
  kicker: { color: "text-gray-515", extraClass: "font-light" },
};
